import React from 'react';
import Header from './components/Header';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';
import {
  Routes,
  Route
} from "react-router-dom";
import Upload from './routes/upload';
import Review from './routes/review';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <div className="App">
        <Header/>
        <main>
          <Routes>
            <Route path={`/`} element={<></>} />
            <Route path={`/upload`} element={<Upload/>} />
            <Route path={`/review`} element={<Review/>} />   
          </Routes>
        </main>
      </div>
    </ErrorBoundary>
  );
};

export default App;
